// Facebook Pixel integration
import { FACEBOOK_PIXEL_ID } from "@/constants";

declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

// Module-level flag to prevent multiple initializations
let isInitialized = false;

export const initializeFacebookPixel = () => {
  // Guard: Prevent multiple initializations
  if (isInitialized) {
    return;
  }

  // Mark as initialized immediately to prevent duplicate calls
  isInitialized = true;

  // Defer loading until after initial render to avoid blocking LCP
  const loadPixel = () => {
    const pixelId = FACEBOOK_PIXEL_ID;

    if (!pixelId) {
      console.warn("Facebook Pixel ID not configured.");
      return;
    }

    // Initialize Facebook Pixel
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

    window.fbq("init", pixelId);
    window.fbq("track", "PageView");

    // Add noscript fallback
    const noscript = document.createElement("noscript");
    const img = document.createElement("img");
    img.height = 1;
    img.width = 1;
    img.style.display = "none";
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.insertBefore(noscript, document.body.firstChild);
  };

  // Use requestIdleCallback for modern browsers, fallback to setTimeout
  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(loadPixel, { timeout: 3000 });
  } else {
    setTimeout(loadPixel, 2000);
  }
};

export const trackEvent = (eventName: string, data?: any) => {
  if (window.fbq) {
    window.fbq("track", eventName, data);
  }
};
